import ky from "ky";
import { auth } from "@app/config/firebase";
import { triggerUnauthorizedModal } from "@shared/ui/UnauthorizedModal/UnauthorizedModal";

export const baseApi = ky.create({
  timeout: false,
  headers: {
    accept: "application/json",
    "content-type": "application/json",
  },
  hooks: {
    afterResponse: [
      async (request, options, response) => {
        if (response.status === 401) {
          await auth.signOut();
        }
        if (response.status === 406) {
          triggerUnauthorizedModal();
        }
      },
      // async (request, options, response) => {
      //   if (response.status === 403) {
      //     const message =
      //       "You do not have permission to view the requested page";
      //     throw new Error(message);
      //   }
      // },
      // async (request, options, response) => {
      //   if (response.status === 500) {
      //     throw new Error(response);
      //   }
      // },
    ],
  },
  prefixUrl: process.env.REACT_APP_API_URL,
});

export const api = baseApi.extend({
  prefixUrl: process.env.REACT_APP_API_URL,
  credentials: "include",
  hooks: {
    beforeRequest: [
      async (request) => {
        const authToken = (await auth.currentUser?.getIdToken()) || "";
        request.headers.set("Authorization", `Bearer ${authToken}`);
      },
    ],
  },
});
